/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Faqsuggestion1Inputs */

const he_contact_faqsuggestion1 = /** @type {(inputs: Contact_Faqsuggestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לפני שאתה פונה אלינו, אולי תמצא את התשובה ב`)
};

const en_contact_faqsuggestion1 = /** @type {(inputs: Contact_Faqsuggestion1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Before reaching out, you might find the answer in the`)
};

/**
* | output |
* | --- |
* | "Before reaching out, you might find the answer in the" |
*
* @param {Contact_Faqsuggestion1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const contact_faqsuggestion1 = /** @type {((inputs?: Contact_Faqsuggestion1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Faqsuggestion1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_contact_faqsuggestion1(inputs)
	return en_contact_faqsuggestion1(inputs)
});
export { contact_faqsuggestion1 as "contact_faqSuggestion" }